import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
const SvgPlus = (props, ref) => (_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: _jsx("path", { d: "M12 5V19M5 12H19", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }));
const ForwardRef = forwardRef(SvgPlus);
export default ForwardRef;
